'use strict';
 
var SiteConstants = require('constants/SiteConstants');
var zonos = require('../zonos');

function setMiniCartBodyMaxHeight(minicart) {
    var $minicart = $(minicart);
    var $minicartScrollable = $minicart.find('.product-summary');
    var minicartHeight = $minicart.outerHeight();
    var minicartScrollableHeight = $minicartScrollable.outerHeight();
    var minicartNonScrollableHeight = minicartHeight - minicartScrollableHeight;
    var minicartOffset = $minicart.offset().top - $(window).scrollTop();
    var subtractHeight = minicartOffset + minicartNonScrollableHeight + SiteConstants.Spacer;

    $minicartScrollable.css('max-height', 'calc(100vh - ' + subtractHeight + 'px)');
}

module.exports = function () {
    var disableMiniCartRoutes = [
        'Checkout-Begin',
        'Cart-Show'
    ]

    $('.minicart').on('count:update', (event, count) => {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
            sessionStorage?.setItem?.('cartcount', count.quantityTotal);
        }
    });

    $('body').on('preload:minicart', () => {

        var $page = $('div.page');
        if ($page.length) {
            var action = $page.data('action');

            if (disableMiniCartRoutes.includes(action)) {
                return;
            }
        }
        var url = $('.minicart').data('action-url');
        $('.minicart .popover').spinner().start();
        $.get(url, data => {
            $('.minicart .popover').empty();
            $('.minicart .popover').append(data);
            $('.minicart-header .close').on('click', event => {
                $('.minicart .popover').removeClass('show');
                $('.minicart-overlay').removeClass('minicart-overlay-hover');
            });
            $.spinner().stop();
            $('body').trigger('minicart:loaded', $('.minicart .popover'));
        });
    });

    $('.minicart').on('mouseenter focusin touchstart', () => {
        // LBH update - prevent minicart from showing on checkout page
        var $page = $('div.page');
        if ($page.length) {
            var action = $page.data('action');
            if ($('.search:visible').length === 0 || disableMiniCartRoutes.includes(action)) {
                return;
            }
        }
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            $('.minicart .popover').addClass('show');
            $('.minicart-overlay').addClass('minicart-overlay-hover');
            zonos.updateZonosPricing();
            $('body').trigger('minicart:loaded', $('.minicart .popover'));
            return;
        }
    });

    $('body').on('touchstart click', event => {
        if ($('.minicart').has(event.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
            $('.minicart-overlay').removeClass('minicart-overlay-hover');
        }
    });


    $('body').on('change', '.minicart .quantity', event => {
        if ($(event.target).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('body').on('minicart:loaded', (event, minicart) => {
        setMiniCartBodyMaxHeight(minicart);
    });
};
